import { Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAvaliacaoRequisitoVagaDto, RespostaAvaliacaoRequisitoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-modal-nova-pergunta',
  templateUrl: './modal-nova-pergunta.component.html',
  styleUrls: ['./modal-nova-pergunta.component.scss']
})
export class ModalNovaPerguntaComponent {
  pergunta: CreateAvaliacaoRequisitoVagaDto = new CreateAvaliacaoRequisitoVagaDto();
  resposta = '';
  tituloSave;
  respostas: RespostaAvaliacaoRequisitoDto[] = [];
  respostaEditavel: RespostaAvaliacaoRequisitoDto = new RespostaAvaliacaoRequisitoDto();
  indiceEdicao: number | null = null;
  @Output() perguntaCriada = new EventEmitter<CreateAvaliacaoRequisitoVagaDto>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (this.pergunta.possiveisRespostasAvaliacaoRequisito) {
      this.respostas = [...this.pergunta.possiveisRespostasAvaliacaoRequisito];
    }
  }

  fechar() {
    this.activeModal.dismiss();
  }

  salvar() {
    if (this.respostas.length > 0 && this.pergunta.avaliacao != "" && this.pergunta.avaliacao != undefined) {
      this.pergunta.possiveisRespostasAvaliacaoRequisito = this.respostas;
      this.perguntaCriada.emit(this.pergunta);
      this.activeModal.close();
    } else {
      abp.notify.error("Por favor, preencha a pergunta e adicione pelo menos uma resposta antes de salvar.");
    }
  }


  adicionarResposta() {
    if (this.respostas && this.respostas.length < 3) {
      this.resposta.trim();
      let novaResposta = new RespostaAvaliacaoRequisitoDto();
      if (this.resposta != "" && this.resposta != undefined) {
        novaResposta.resposta = this.resposta;
        this.respostas.push(novaResposta);
        this.resposta = '';
      } else {
        abp.notify.error("Preencha a resposta");
      }
    } else {
      abp.notify.error("Limite de respostas atingido. Remova uma para adicionar outra.");
    }
  }


  removerResposta(indice: number) {
    this.respostas.splice(indice, 1);
  }

  iniciarEdicao(indice: number, resposta: RespostaAvaliacaoRequisitoDto) {
    this.indiceEdicao = indice;
    this.respostaEditavel = resposta;
  }

  salvarEdicao() {
    if (this.indiceEdicao !== null) {
      this.respostas[this.indiceEdicao] = this.respostaEditavel;
      this.cancelarEdicao();
    }
  }

  cancelarEdicao() {
    this.indiceEdicao = null;
    this.respostaEditavel = new RespostaAvaliacaoRequisitoDto();
  }
}
